//Get Tenant Domain
export const getTenant = () =>  {
    const tenantLs = localStorage.getItem("Tenant");
    if(!tenantLs) return null;
    const tenant = JSON.parse(tenantLs);
    if(!tenant) return null;
    return tenant;
}
